<!-- 近效期预警 -->
<template>
	<div class='page_content'>
		<div class="page_content_top">
			<div class="page_content_top_line">
				<el-button type="primary" icon="el-icon-refresh"  size="mini" @click="getDataList()" >
					刷新
				</el-button>
			</div>
			<div class="page_content_top_line">
				<el-form :inline="true" class="demo-form-inline" size="mini">
					<el-form-item label="未销售天数">
						<el-input  v-model.number="getRequestData.unSalableDays">
						</el-input>
					</el-form-item>
                    <el-form-item label="开始时间">
                        <el-date-picker size="mini" v-model="getRequestData.start" format="yyyy MM月 dd日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                     <el-form-item label="结束时间">
                        <el-date-picker size="mini" v-model="getRequestData.end" format="yyyy MM月 dd日" value-format="timestamp" type="date" placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
					<el-form-item>
						<el-button type="primary"  size="mini" @click="searchData">查询</el-button>
					</el-form-item>
					
				</el-form>
			</div>
		</div>
		<div class="page_content_center">
			<el-table size="mini"  stripe :data="returnData.list"  height="100%" border  style="width: 100%" highlight-current-row>
				<el-table-column prop="bgmName"  label="通用名称" show-overflow-tooltip></el-table-column>
				<el-table-column prop="lotno"  label="批次" show-overflow-tooltip></el-table-column>
				<el-table-column prop="batchno"  label="批号" show-overflow-tooltip></el-table-column>
				<el-table-column prop="manufacturer"  label="生产厂家" show-overflow-tooltip></el-table-column>
				<el-table-column prop="spec"  label="规格" show-overflow-tooltip></el-table-column>
				<el-table-column prop="placeorigin"  label="产地" show-overflow-tooltip></el-table-column>
				<el-table-column prop="outRate"  label="销项税率"></el-table-column>
				<el-table-column prop="psprice"  label="含税价格"></el-table-column>
				<el-table-column prop="psmoney"  label="含税金额"></el-table-column>
				<el-table-column prop="price"  label="成本单价"></el-table-column>
				<el-table-column prop="prodate"  label="生产日期">
					<template  slot-scope="scope">
						<div v-if="scope.row.prodate">
							{{$common.getLocalTime(scope.row.prodate)}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="expidate"  label="失效日期">
					<template  slot-scope="scope">
						<div v-if="scope.row.expidate">
							{{$common.getLocalTime(scope.row.expidate)}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="sterBatchno"  label="灭菌批号" show-overflow-tooltip></el-table-column>
				<el-table-column prop="money"  label="当前库存金额"></el-table-column>
				<el-table-column prop="num"  label="当前库存数量"></el-table-column>
				<el-table-column prop="coName"  label="货主名字" show-overflow-tooltip></el-table-column>
				<el-table-column prop="frozenNum"  label="冻结数量"></el-table-column>
				<el-table-column prop="stName"  label="库房名字" show-overflow-tooltip></el-table-column>
			</el-table>
		</div>
		<div class="page_content_bottom">
			<el-pagination
				background
				@size-change="setDataPageSize"
				@current-change="setDataPageNumber"
				:current-page="getRequestData.page"
				:page-sizes="[30,50,100,500]"
				:page-size="30"
				layout="total, sizes, prev, pager, next, jumper"
				:total="returnData.total">
			</el-pagination>
		</div>
	</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	//import引入的组件需要注入到对象中才能使用
	components: {},
	data() {
		//这里存放数据
		return {
			
			getRequestData:{
				unSalableDays:'',
				page:1,
				rows:30,
				start:
                    new Date(new Date().toLocaleDateString()).getTime() -
                    31 * 24 * 3600 * 1000,
                end:
                    new Date(new Date().toLocaleDateString()).getTime() +
                    24 * 60 * 60 * 1000 -
                    1,
			},
			returnData:{
				pages:0,  // 总页数
				total:0,  // 总条数
				pageNum:0,  // 当前页数
				list:[]
			},
			
			
			
			
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
	},
	//方法集合
	methods: {
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
		// 数据搜索
		searchData() {
			this.getRequestData.page = 1
			this.getDataList()
		},
		// 数据翻页
		setDataPageNumber(val){
			this.getRequestData.page = val
			this.getDataList()
		},
		
		// 切换显示条数
		setDataPageSize(val){
			this.getRequestData.page = 1
			this.getRequestData.rows = val
			this.getDataList()
		},
		
		
		// 获取数据列表
		async getDataList(){
			let responseData =  await this.$http.getUnsalableWaring(this.getRequestData)
			if(responseData.status == 200){
				this.returnData.list = responseData.result.list
				this.returnData.pages = responseData.result.pages
				this.returnData.total = responseData.result.total
				this.returnData.pageNum = responseData.result.pageNum
			}else{
				this.$message({
					message: responseData.message,
					type: 'error'
				});
			}
		},
		
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getDataList()
		
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {

	},
	beforeCreate() {}, //生命周期 - 创建之前
	beforeMount() {}, //生命周期 - 挂载之前
	beforeUpdate() {}, //生命周期 - 更新之前
	updated() {}, //生命周期 - 更新之后
	beforeDestroy() {}, //生命周期 - 销毁之前
	destroyed() {}, //生命周期 - 销毁完成
	activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

